import { render, staticRenderFns } from "./AwaitModuleCopy.vue?vue&type=template&id=6443a1b2&"
import script from "./AwaitModuleCopy.vue?vue&type=script&lang=js&"
export * from "./AwaitModuleCopy.vue?vue&type=script&lang=js&"
import style0 from "./AwaitModuleCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports